// iter98 — Shared helpers for the new Partner Account pages.
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmtMoney = (cents) =>
  ((cents || 0) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return iso;
  }
};

export const getToken = () =>
  typeof window !== 'undefined' ? localStorage.getItem('nofee_partner_token') : null;

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });
